import React, { useState, useEffect, useMemo } from 'react';
import {
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IAuthReduxProps, IConsultationClientTable, ITarget } from '../../types/interfaces';
import ClientScanModal from '../client/ClientScanModal';
import ClientEdit from '../client/ClientEdit';

import { getFtpScan } from '../../flux/actions/clientActions';
import TableContainer from "../tables_manager/TableContainer"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faInfoCircle, faExternalLinkAlt, faPrint, faPhone, faClipboard, faCheckCircle, faIdCard, faPen, faSearch } from '@fortawesome/free-solid-svg-icons'
import moment from "moment";
import { E_ERROR } from '../../types/errors';
import { useHistory } from 'react-router-dom';
import { useAlert } from "react-alert";
import Loading from '../Loading';
import ReactTooltip from 'react-tooltip';
import PDFLink from '../pdf/PDFLink';
import { PRIVILEGE } from '../../types/privileges';

const ConsultationClientTable = ({ 
  linesData,
  embed,
  auth
 }: IConsultationClientTable) => {
  const history = useHistory();
  const alert = useAlert();
  
  const [copiedFlag, setCopiedFlag] = useState(false);
  const [copiedFlag2, setCopiedFlag2] = useState(false);
  const [modalScan, setModalScan] = useState(false);
  const [modalScanClient, setModalScanClient] = useState('');
  const [modalEdit, setModalEdit] = useState(false);
  const [modalClient, setModalClient] = useState('');

  const handleCopy = (e, id = 1) => {
    let phone = (e || "").toString().replace(/ /g,'');
    if(phone.length >= 4 && phone[0] !== "0")
      phone = "+" + phone
    alert.info(`Le numéro de téléphone "${phone}" a été copié.`);
    window.navigator.clipboard.writeText(phone);
    if(id == 1){
      setCopiedFlag(true);
      setTimeout(() => setCopiedFlag(false), 2000);
    }
    else if(id == 2){
      setCopiedFlag2(true);
      setTimeout(() => setCopiedFlag2(false), 2000);
    }
  };

  const columns = [
      {
        Header: "ID Client",
        accessor: "id",
        hidden: embed
      },
      {
        Header: "Nom complet",
        accessor: "nom_complet",
        customExportDisplay: `($.NOM || "-") + " " + ($.PRENOM || "")`,
        filter: (rows, id, e) => rows.filter(t => t.original.NOM?.toString().toLowerCase().includes((e || "").toLowerCase()) || t.original.PRENOM?.toString().toLowerCase().includes((e || "").toLowerCase())),
        Cell: ({ row: {original} }) => `${original.NOM || "-"} ${original.PRENOM || ""}`
      },
      // {
      //   Header: "Nom",
      //   accessor: "NOM",
      // },
      // {
      //   Header: "Prénom",
      //   accessor: "PRENOM",
      // },
      {
        Header: "CIN/Passeport",
        accessor: e => e.PASSPORT || e.CIN || "",
        Cell: ({ value }) => {
          return (<div className="fullFlexCenter">
            {value || "-"}
            {!!value && <FontAwesomeIcon icon={faSearch} title="Chercher dans les biens vendus" className="cinLookupIcon" onClick={e => {
              if (e.ctrlKey){
                window.open("/consultation?cp=" + value, '_blank');
                return;
              }
              history.push({ pathname: `/consultation`, search: "?cp=" + value})
            }} />}
          </div>)
        }
      },
      // {
      //   Header: "Numéro(s) de Téléphone",
      //   accessor: "TEL",
      //   disableSortBy: true,
      //   Cell: ({ row }) => row.original.TEL || row.original.TEL2 ? <div>
      //     {row.original.TEL ? <div>
      //       {row.original.TEL}
      //       <a data-tip data-for="telI" href={`tel:${row.original.TEL?.replace(/ /g,'')}`} style={{marginLeft: "5px", marginRight: "10px"}}><FontAwesomeIcon icon={faPhone} /></a>
      //       <FontAwesomeIcon icon={faClipboard} data-tip data-for="tel" style={{cursor: "pointer"}} onClick={() => handleCopy(row.original.TEL)} />
      //       <ReactTooltip effect="solid" place="bottom" id="tel" type={copiedFlag ? "success" : "dark"}>
      //         <FontAwesomeIcon icon={copiedFlag ? faCheckCircle : faClipboard} />&nbsp;&nbsp;{copiedFlag ? "Copié" : "Copier"}
      //       </ReactTooltip>
      //     </div> : null}
      //     {row.original.TEL2 ? <div>
      //       {row.original.TEL2}
      //       <a data-tip data-for="telI" href={`tel:${row.original.TEL2?.replace(/ /g,'')}`} style={{marginLeft: "5px", marginRight: "10px"}}><FontAwesomeIcon icon={faPhone} /></a>
      //       <FontAwesomeIcon icon={faClipboard} data-tip data-for="tel2" style={{cursor: "pointer"}} onClick={() => handleCopy(row.original.TEL2, 2)} />
      //       <ReactTooltip effect="solid" place="bottom" id="tel2" type={copiedFlag2 ? "success" : "dark"}>
      //         <FontAwesomeIcon icon={copiedFlag2 ? faCheckCircle : faClipboard} />&nbsp;&nbsp;{copiedFlag2 ? "Copié" : "Copier"}
      //       </ReactTooltip>
      //     </div> : null}
      //   </div> : "-"
      // },
      {
        Header: "Numéro(s) de Téléphone",
        accessor: "TEL",
        disableSortBy: true,
        Cell: ({ row }) => row.original.TEL || row.original.TEL2 ? <div>
          {row.original.TEL ? <div style={{whiteSpace: "nowrap"}}>
            {row.original.TEL.length >= 4 && row.original.TEL[0] !== "0" ? ("+" + row.original.TEL) : row.original.TEL}
            <a data-tip data-for="telI" href={`tel:${(row.original.TEL.length >= 4 && row.original.TEL[0] !== "0" ? ("+" + row.original.TEL) : row.original.TEL).replace(/ /g,'')}`} style={{marginLeft: "5px", marginRight: "10px"}}><FontAwesomeIcon icon={faPhone} /></a>
            <ReactTooltip effect="solid" place="bottom" id="telI" type="dark"><b>Appeler</b></ReactTooltip>
            <FontAwesomeIcon icon={faClipboard} data-tip data-for="tel" style={{cursor: "pointer"}} onClick={() => handleCopy(row.original.TEL)} />
            <ReactTooltip effect="solid" place="bottom" id="tel" type={copiedFlag ? "success" : "dark"}>
              <FontAwesomeIcon icon={copiedFlag ? faCheckCircle : faClipboard} />&nbsp;&nbsp;{copiedFlag ? "Copié" : "Copier"}
            </ReactTooltip>
          </div> : null}
          {row.original.TEL2 ? <div style={{whiteSpace: "nowrap"}}>
            {row.original.TEL2.length >= 4 && row.original.TEL2[0] !== "0" ? ("+" + row.original.TEL2) : row.original.TEL2}
            <a data-tip data-for="telI2" href={`tel:${(row.original.TEL2.length >= 4 && row.original.TEL2[0] !== "0" ? ("+" + row.original.TEL2) : row.original.TEL2).replace(/ /g,'')}`} style={{marginLeft: "5px", marginRight: "10px"}}><FontAwesomeIcon icon={faPhone} /></a>
            <ReactTooltip effect="solid" place="bottom" id="telI2" type="dark"><b>Appeler</b></ReactTooltip>
            <FontAwesomeIcon icon={faClipboard} data-tip data-for="tel2" style={{cursor: "pointer"}} onClick={() => handleCopy(row.original.TEL2, 2)} />
            <ReactTooltip effect="solid" place="bottom" id="tel2" type={copiedFlag2 ? "success" : "dark"}>
              <FontAwesomeIcon icon={copiedFlag2 ? faCheckCircle : faClipboard} />&nbsp;&nbsp;{copiedFlag2 ? "Copié" : "Copier"}
            </ReactTooltip>
          </div> : null}
        </div> : "-"
      },
      {
        Header: "Aperçus",
        className: "text-center",
        Cell: ({ row }) => (
            <Container className="actionsContainer">
                {/* <button className="btn btn-danger btn-rounded btn-sm my-0 waves-effect waves-light"
                  onClick={() => deleteTableClientC(row.original.id)}
                  title="Supprimer de cette liste">
                  <FontAwesomeIcon icon={faTrash} />
                </button> */}
                {/* <button className="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light"
                  onClick={() => alert.info("en construction")}
                  title="Imprimer la fiche du client">
                  <FontAwesomeIcon icon={faPrint} />
                </button> */}
                {!!auth?.user?.privileges?.includes(PRIVILEGE.EDIT_CLIENTS) && <button className="btn btn-warning btn-rounded btn-sm my-0 waves-effect waves-light"
                  onClick={() => {setModalClient(row.original); setModalEdit(true)}}
                  title="Modifier">
                  <FontAwesomeIcon icon={faPen} />
                </button>}
                <PDFLink documentType={"client"}
                  data={row.original}
                  download={false}
                  buttonText=""
                  iconSize="inherit"
                  customClassNames="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  customButtonIcon={faPrint}
                  allowPrintPreview={true}
                  htmlTitle="Imprimer la fiche du client" />
                {row.original.cin_name || row.original.passport_name ? <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  onClick={() => (setModalScanClient(row.original), setModalScan(true))}
                  title="Aperçu des Scans">
                  <FontAwesomeIcon icon={faIdCard} />
                </button> : null}
            </Container>
        ),
        disableSortBy: true,
     }
  ];

  return (
    <div style={embed ? {maxWidth: "100%"} : {}}>
      <Container>
        <TableContainer columns={columns} data={linesData} dataName="clients" enableCheckBox={false} disableFilter={true} hideExport={!!embed} />
      </Container>
      <ClientEdit modal={modalEdit} setModal={setModalEdit} modalClient={modalClient} />

      <ClientScanModal modal={modalScan} setModal={setModalScan} modalClient={modalScanClient} setModalClient={setModalScanClient} />
      {/* <Modal isOpen={modalScan} toggle={handleToggleScan} onOpened={modalOpenedHandleScan} onClosed={modalClosedHandleScan} className="modal-dialog-large">
        <ModalHeader toggle={handleToggleScan}><FontAwesomeIcon icon={faIdCard} />&nbsp;&nbsp;Aperçu des Scans{modalScanClient && (modalScanClient["CIN"] || modalScanClient["PASSPORT"]) ? (" - " + (modalScanClient["CIN"] || modalScanClient["PASSPORT"])) : ""}</ModalHeader>
        <ModalBody>
          <Container className="scanPreviewContainer">
            {CINImg || CINLoading ? <Row>
              <Col xs="12">CIN</Col>
              <Col xs="12">{CINLoading ? <Loading /> : <img className="scanPreview" src={CINImg}/>}</Col>
            </Row> : null}
            {passportImg || passportLoading ? <Row>
              <Col xs="12">Passeport</Col>
              <Col xs="12">{passportLoading ? <Loading /> : <img className="scanPreview" src={passportImg}/>}</Col>
            </Row> : null}
          </Container>
        </ModalBody>
      </Modal> */}
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, {  })(ConsultationClientTable);
